angular.module('impactx.search').controller('ProductItemActionsCtrl', [
    'AddToBasketService',
    '$context',
    'productComparison',
    'FavoritesService',
    'TranslationService',
    'ProductViewService',
    'ThemeWorldService',
    'AppConfiguration',
    'RFQSearchService',
    ProductItemActionsController
]);

function ProductItemActionsController(AddToBasketService, $context, productComparison, FavoritesService, TranslationService,
                                      ProductViewService, ThemeWorldService, AppConfiguration, RFQSearchService) {
    var self = this;
    self.selectSupplier = AddToBasketService.selectSupplier;

    /**
     * Returns the view (VCAT) the product details should link back to. Falls back to the view the
     * backend resolved for this product, because search results are not bound to a single catalog
     * and therefore pass no vCatId.
     */
    self.getTargetVCatId = function () {
        return self.vCatId ? self.vCatId : (self.product && self.product.vcatalog ? self.product.vcatalog.id : null);
    };
    self.trns = {
        addToProductComparison: TranslationService.get('addToProductComparison'),
        addToFavorites: TranslationService.get('addToFavorites'),
        removeFromFavorites: TranslationService.get('removeFromFavorites'),
        configure: TranslationService.get('configureProduct'),
        addToBasket: TranslationService.get('addToBasket'),
        addToSupplierBasket: TranslationService.get("addToSupplierBasket"),
        selectSupplier: TranslationService.get('selectSupplier'),
        add: TranslationService.get('add'),
        remove: TranslationService.get('remove'),
        amount: TranslationService.get('amount'),
        addFreeform: TranslationService.get('addFreeForm'),
        addToRFQS : TranslationService.get('addToRFQS'),
        addToRFQH : TranslationService.get('addToRFQH'),
        removeAllConfigs: TranslationService.get('removeAllFromProductView'),
        addAllConfigs: TranslationService.get('addAllToProductView'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromProductView: TranslationService.get('removeFromProductView'),
        addToProductView: TranslationService.get('addToProductView'),
    };
    self.addToBasketTimeout = AppConfiguration.get("addToBasketTimeout");

    self.$onInit = function () {
        var hasComparisonProcess = $context.$securityManager.isProcessAllowed("CompareProducts");
        var hasFavoriteProcess = $context.$securityManager.isProcessAllowed("Favorite");
        self.comparisonAllowed = self.product.canBeAddedToProductComparison && hasComparisonProcess;
        self.favoritesAllowed = self.product.canBeAddedToFavorites && hasFavoriteProcess && !self.product.externalId;
        self.addToRFQS = RFQSearchService.addToRFQS;
        self.addToRFQH = RFQSearchService.addToRFQH;
        self.addToBasket = AddToBasketService.addToBasket;
        self.hideAmountField = AppConfiguration.get('hideAmountField');

        self.hasActions = (!self.product.isConfigProduct || !self.product.basketLink.price.startPrice) &&
            (self.comparisonAllowed || self.favoritesAllowed) || self.hasConfigProductThemeWorldOrProductViewAction();
    };

    self.hasConfigProductThemeWorldOrProductViewAction = function () {
        return self.product.isConfigProduct && (self.canRemoveFromThemeWorld() || self.canRemoveAllFromThemeWorld() || self.canAddToThemeWorld() || self.canAddAllToThemeWorld() 
            || self.canRemoveFromProductView() || self.canRemoveAllFromProductView() || self.canAddToProductView() || self.canAddAllToProductView());
    }
    
    self.canRemoveFromThemeWorld = function() {
        return self.product && self.product.basketLink && self.product.basketLink.canRemoveFromThemeWorld;
    }

    self.canRemoveAllFromThemeWorld = function() {
        return self.product && self.product.basketLink && self.product.isConfigProduct && (self.product.basketLink.canRemoveFromThemeWorld || self.product.basketLink.hasOtherConfigurationsInThemeWorld);
    }

    self.canAddToThemeWorld = function() {
        return self.product && self.product.basketLink && self.product.basketLink.canAddToThemeWorld;
    }

    self.canAddAllToThemeWorld = function() {
        return self.product && self.product.basketLink && self.product.isConfigProduct && (self.product.basketLink.canAddToThemeWorld || self.product.basketLink.hasOtherConfigurationsNotInThemeWorld);
    }

    self.canRemoveFromProductView = function() {
        return self.product && self.product.basketLink && self.product.basketLink.canRemoveFromProductView;
    }

    self.canRemoveAllFromProductView = function() {
        return self.product && self.product.basketLink && self.product.isConfigProduct && (self.product.basketLink.canRemoveFromProductView || self.product.basketLink.hasOtherConfigurationsInProductView);
    }

    self.canAddToProductView = function() {
        return self.product && self.product.basketLink && self.product.basketLink.canAddToProductView;
    }

    self.canAddAllToProductView = function() {
        return self.product && self.product.basketLink && self.product.isConfigProduct && (self.product.basketLink.canAddToProductView || self.product.basketLink.hasOtherConfigurationsNotInProductView);
    }

    self.addToProductView = function(event) {
        ProductViewService.addProductsToProductView([self.product], event);
    };

    self.addAllToProductView = function(event) {
        ProductViewService.addAllProductConfigsToProductView([self.product], event);
    };

    self.removeFromProductView = function() {
        var proIds = [];
        self.product.basketLink.canAddToProductView = true;
        self.product.basketLink.canRemoveFromProductView = false;
        proIds.push(self.product.id);
        ProductViewService.removeProductsFromProductView($context.hasActiveProductView.id, proIds);
    };

    self.removeAllFromProductView = function() {
        var proIds = [];
        self.product.basketLink.canAddToProductView = true;
        self.product.basketLink.canRemoveFromProductView = false;
        self.product.basketLink.hasOtherConfigurationsInProductView = false;
        self.product.basketLink.hasOtherConfigurationsNotInProductView = true;
        proIds.push(self.product.id);
        ProductViewService.removeAllProductConfigsFromProductView($context.hasActiveProductView.id, proIds);
    };

    self.addToThemeWorld = function() {
        ThemeWorldService.addProductsToThemeWorld([self.product]);
    };

    self.addAllToThemeWorld = function() {
        ThemeWorldService.addAllProductConfigsToThemeWorld([self.product]);
    };

    self.removeFromThemeWorld = function() {
        var proIds = [];
        self.product.basketLink.canAddToThemeWorld = true;
        self.product.basketLink.canRemoveFromThemeWorld = false;
        proIds.push(self.product.id);
        ThemeWorldService.removeProductsFromThemeWorld($context.hasActiveThemeWorld.id, proIds);
    };

    self.removeAllFromThemeWorld = function() {
        var proIds = [];
        self.product.basketLink.canAddToThemeWorld = true;
        self.product.basketLink.canRemoveFromThemeWorld = false;
        self.product.basketLink.hasOtherConfigurationsInThemeWorld = false;
        self.product.basketLink.hasOtherConfigurationsNotInThemeWorld = true;
        proIds.push(self.product.id);
        ThemeWorldService.removeAllProductConfigsFromThemeWorld($context.hasActiveThemeWorld.id, proIds);
    };

    self.addToComparison = function () {
        if (self.product.fromBackgroundSearch || self.product.isUnite) {
            productComparison.addExternalProductToComparison(self.product);
        }
        else {
            productComparison.addToComparison(self.product.id);
        }
    };

    self.addToFavorites = function () {
        FavoritesService.add(self.product);
    };

    self.addFreeFrom = function (event, product) {
        AddToBasketService.addFreeform(product, event);
    };

    self.removeFromFavorites = function () {
        FavoritesService.remove(self.product);
    };
    
    self.addProductToBasket = function (event, product, vcatId) {
        if(self.addToBasketTimeout > 0)
        {
            const button = event.target;
            button.disabled = true;
            setTimeout(() => { button.disabled = false; }, self.addToBasketTimeout);
        }

        AddToBasketService.addProductToBasket(event, product, vcatId).then(function () {
            if (impactX.isDefined(product, 'basketLink.amount')) {
                delete product.basketLink.amount;
            }
        });
    };

    self.addExternalProductToBasket = function (event, product, amount) {
        AddToBasketService.addExternalProductToBasket(event, product, amount);
    };
}